import { Signatory } from '@interfaces/report-templates.interface';
import { AuditServiceType } from '@types/graphql-global-types';
import { auditRecordIdPrefixes } from '@queries/generated/audit.generated';

export const signatoriesGridColumnHelper = (
    signatories: Signatory[],
    prefixes?: auditRecordIdPrefixes['auditRecordIdPrefixes'],
): Signatory[] => {
    const recordIdPrefix = prefixes?.find((p) => p?.service === AuditServiceType.REPORTING)?.prefix;

    return signatories.map((signatory) => ({
        ...signatory,
        _itemId: `${recordIdPrefix}${signatory.recordId}`,
    }));
};
